module.exports = __webpack_public_path__ + "static/media/hexagon-landing-page-feature.d4502e88.jpg";